import { render } from "./ListaTareas.vue?vue&type=template&id=dce5c4e6"
import script from "./ListaTareas.vue?vue&type=script&lang=js"
export * from "./ListaTareas.vue?vue&type=script&lang=js"

import exportComponent from "/home/jean/web/lienzo/anden_dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__